import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {},
} = checkout;

const validation = Yup.object().shape({});

export default validation;
